// extracted by mini-css-extract-plugin
export default {"container":"OS-z","modal":"PS-z","dimensions":"QS-z","brandName":"RS-z","productName":"SS-z","recipientEmail":"TS-z","recommendedFit":"US-z","hiddenField":"VS-z"};